import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import theme from '../../theme';
import * as groceryApi from '../grocery/groceryApi';
import * as pantryApi from './pantryApi';

var Page = styled.div`
  padding: 16px;
  max-width: 900px;
  margin: 0 auto;
  color: ${theme.text};
`;

var Section = styled.div`
  margin-bottom: 24px;
`;

var SectionTitle = styled.h3`
  color: ${theme.accent};
  font-size: 1rem;
  margin: 0 0 12px 0;
`;

var TagInput = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
`;

var Input = styled.input`
  flex: 1;
  padding: 12px;
  border: 2px solid ${theme.border};
  border-radius: ${theme.radiusSm};
  background: ${theme.bg};
  color: #fff;
  font-size: 1rem;
  min-height: 48px;
  &:focus { outline: none; border-color: ${theme.accent}; }
  &::placeholder { color: ${theme.textPlaceholder}; }
`;

var AddBtn = styled.button`
  padding: 12px 20px;
  border: none;
  border-radius: ${theme.radiusSm};
  background: ${theme.accentGradient};
  color: #000;
  font-weight: 700;
  cursor: pointer;
  min-height: 48px;
  white-space: nowrap;
`;

var Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

var Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: ${theme.radiusPill};
  background: rgba(74,222,128,0.15);
  border: 1px solid ${theme.accent}44;
  color: #fff;
  font-size: 0.85rem;
`;

var TagRemove = styled.button`
  background: none;
  border: none;
  color: ${theme.error};
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0;
  line-height: 1;
  &:hover { opacity: 0.7; }
`;

var SearchBtn = styled.button`
  padding: 14px 28px;
  border: none;
  border-radius: ${theme.radiusSm};
  background: ${theme.accentGradient};
  color: #000;
  font-weight: 700;
  cursor: pointer;
  min-height: 48px;
  font-size: 1rem;
  margin-bottom: 20px;
  &:hover { transform: translateY(-1px); }
  &:disabled { opacity: 0.5; cursor: default; transform: none; }
`;

var Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  @media (min-width: 600px) { grid-template-columns: 1fr 1fr; }
`;

var Card = styled.div`
  background: ${theme.bgCard};
  border: 1px solid ${theme.border};
  border-radius: ${theme.radius};
  padding: 20px;
  &:hover { border-color: ${theme.borderLight}; }
`;

var CardTitle = styled.h3`
  margin: 0 0 8px 0;
  color: #fff;
  font-size: 1.1rem;
`;

var CategoryBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: ${theme.radiusPill};
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  background: ${p => p.$color ? p.$color + '22' : 'rgba(255,255,255,0.1)'};
  color: ${p => p.$color || theme.textMuted};
  border: 1px solid ${p => p.$color ? p.$color + '44' : theme.border};
`;

var Meta = styled.div`
  display: flex;
  gap: 14px;
  margin: 8px 0;
  font-size: 0.8rem;
  color: ${theme.textMuted};
`;

var Desc = styled.p`
  color: ${theme.textMuted};
  font-size: 0.85rem;
  margin: 8px 0;
  line-height: 1.4;
`;

var IngList = styled.div`
  margin: 8px 0;
  padding: 10px;
  background: rgba(0,0,0,0.2);
  border-radius: ${theme.radiusSm};
`;

var IngItem = styled.div`
  font-size: 0.8rem;
  color: ${theme.text};
  padding: 2px 0;
`;

var IngLabel = styled.div`
  font-size: 0.75rem;
  font-weight: 700;
  color: ${theme.accent};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

var MatchBadge = styled.span`
  display: inline-block;
  padding: 4px 10px;
  border-radius: ${theme.radiusPill};
  font-size: 0.7rem;
  font-weight: 700;
  background: ${theme.accent}22;
  color: ${theme.accent};
  border: 1px solid ${theme.accent}44;
  margin-left: 8px;
`;

var AddToListBtn = styled.button`
  padding: 8px 14px;
  border: 1px solid ${theme.accent};
  border-radius: ${theme.radiusSm};
  background: transparent;
  color: ${theme.accent};
  cursor: pointer;
  font-size: 0.8rem;
  margin-top: 10px;
  &:hover { background: rgba(74,222,128,0.1); }
  &:disabled { opacity: 0.4; cursor: default; }
`;

var Empty = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: ${theme.textDim};
  font-size: 1.1rem;
`;

var QuickAdd = styled.button`
  padding: 6px 12px;
  border: 1px dashed ${theme.border};
  border-radius: ${theme.radiusPill};
  background: transparent;
  color: ${theme.textMuted};
  cursor: pointer;
  font-size: 0.8rem;
  &:hover { border-color: ${theme.accent}; color: ${theme.accent}; }
`;

var PantryHint = styled.p`
  color: ${theme.textMuted};
  font-size: 0.85rem;
  line-height: 1.45;
  margin: 0 0 14px 0;
`;

var SnapCard = styled.div`
  background: ${theme.bgCard};
  border: 1px solid ${theme.border};
  border-radius: ${theme.radius};
  padding: 16px;
  margin-bottom: 14px;
`;

var SnapHead = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
`;

var SnapTitle = styled.div`
  font-weight: 700;
  color: #fff;
  font-size: 1rem;
`;

var SnapMeta = styled.span`
  font-size: 0.75rem;
  color: ${theme.textMuted};
`;

var LineRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid ${theme.border};
  &:last-child { border-bottom: none; }
`;

var HavePill = styled.button`
  padding: 4px 10px;
  border-radius: ${theme.radiusPill};
  border: 1px solid ${p => p.$have ? theme.accent + '88' : theme.error + '88'};
  background: ${p => p.$have ? 'rgba(74,222,128,0.12)' : 'rgba(255,82,82,0.1)'};
  color: ${p => p.$have ? theme.accent : theme.error};
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

var RowActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: auto;
`;

var SnapToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
`;

var GhostBtn = styled.button`
  padding: 6px 12px;
  border-radius: ${theme.radiusSm};
  border: 1px solid ${theme.border};
  background: transparent;
  color: ${theme.textMuted};
  font-size: 0.78rem;
  cursor: pointer;
  &:hover { border-color: ${theme.accent}; color: ${theme.accent}; }
`;

var DangerGhost = styled(GhostBtn)`
  &:hover { border-color: ${theme.error}; color: ${theme.error}; }
`;

var NewSnapBox = styled.div`
  background: rgba(0,0,0,0.2);
  border: 1px dashed ${theme.border};
  border-radius: ${theme.radius};
  padding: 14px;
  margin-bottom: 20px;
`;

var LineEditor = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;

var SmallInp = styled.input`
  flex: 1;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid ${theme.border};
  border-radius: ${theme.radiusSm};
  background: ${theme.bg};
  color: #fff;
  font-size: 0.9rem;
`;

var FlashOk = styled.div`
  font-size: 0.85rem;
  color: ${theme.accent};
  margin-bottom: 10px;
`;

var CATEGORY_COLORS = {
  breakfast: theme.breakfast,
  lunch: theme.lunch,
  dinner: theme.dinner,
  snack: theme.snack,
  dessert: theme.dessert,
  side: theme.side
};

var COMMON_INGREDIENTS = ['chicken', 'rice', 'pasta', 'eggs', 'butter', 'onion', 'garlic', 'tomato', 'cheese', 'milk', 'bread', 'potato'];

var STAPLE_PRESETS = [
  'Milk', 'Butter', 'Eggs', 'Bread', 'Cheese', 'Yogurt', 'Coffee', 'Onions', 'Garlic',
  'Rice', 'Pasta', 'Olive oil', 'Salt', 'Potatoes', 'Tomatoes', 'Lettuce', 'Chicken',
];

var WhatCanIMakePage = function ({ onLogout }) {
  var [ingredients, setIngredients] = useState([]);
  var [inputVal, setInputVal] = useState('');
  var [results, setResults] = useState(null);
  var [loading, setLoading] = useState(false);
  var [addedSet, setAddedSet] = useState({});

  var [snapshots, setSnapshots] = useState([]);
  var [snapshotsLoading, setSnapshotsLoading] = useState(true);
  var [snapTitle, setSnapTitle] = useState('');
  var [snapLines, setSnapLines] = useState([]);
  var [snapSaving, setSnapSaving] = useState(false);
  var [pantryFlash, setPantryFlash] = useState('');

  var addIngredient = function (name) {
    var trimmed = (name || '').trim().toLowerCase();
    if (!trimmed) return;
    if (ingredients.includes(trimmed)) return;
    setIngredients(function (prev) { return [...prev, trimmed]; });
    setInputVal('');
  };

  var handleSubmit = function (e) {
    e.preventDefault();
    addIngredient(inputVal);
  };

  var removeIngredient = function (name) {
    setIngredients(function (prev) { return prev.filter(function (i) { return i !== name; }); });
  };

  var search = useCallback(async function () {
    if (!ingredients.length) return;
    setLoading(true);
    setAddedSet({});
    try {
      var url = '/api/what-can-i-make?ingredients=' + encodeURIComponent(ingredients.join(','));
      var res = await fetch(url, { credentials: 'include' });
      if (res.status === 401) { onLogout(); return; }
      var data = await res.json();
      setResults(data);
    } catch (err) {}
    setLoading(false);
  }, [ingredients, onLogout]);

  var addToGrocery = async function (recipe) {
    if (!recipe.ingredients?.length) return;
    try {
      var items = recipe.ingredients.map(function (ing) {
        return { name: ing.name, amount: ing.amount, unit: ing.unit, category: ing.category || 'other', recipeSource: recipe.title };
      });
      await groceryApi.addItemsBulk(items);
      setAddedSet(function (prev) { var n = {}; n[recipe._id] = true; return Object.assign({}, prev, n); });
    } catch (err) {}
  };

  var suggestions = COMMON_INGREDIENTS.filter(function (c) { return !ingredients.includes(c); });

  var loadSnapshots = useCallback(async function () {
    setSnapshotsLoading(true);
    try {
      var list = await pantryApi.fetchSnapshots();
      setSnapshots(Array.isArray(list) ? list : []);
    } catch (err) {
      if (String(err.message || '').indexOf('Session expired') !== -1) onLogout();
    }
    setSnapshotsLoading(false);
  }, [onLogout]);

  useEffect(function () {
    loadSnapshots();
  }, [loadSnapshots]);

  var fillStapleTemplate = function () {
    setSnapLines(STAPLE_PRESETS.map(function (name) { return { name: name, have: true }; }));
  };

  var addBlankSnapLine = function () {
    setSnapLines(function (prev) { return prev.concat([{ name: '', have: false }]); });
  };

  var setSnapLine = function (idx, patch) {
    setSnapLines(function (prev) {
      return prev.map(function (row, i) {
        if (i !== idx) return row;
        return Object.assign({}, row, patch);
      });
    });
  };

  var removeSnapLine = function (idx) {
    setSnapLines(function (prev) { return prev.filter(function (_, i) { return i !== idx; }); });
  };

  var saveNewSnapshot = async function () {
    var lines = snapLines
      .map(function (L) { return { name: String(L.name || '').trim(), have: !!L.have }; })
      .filter(function (L) { return L.name; });
    if (!lines.length) {
      setPantryFlash('Add at least one item with a name.');
      return;
    }
    setSnapSaving(true);
    setPantryFlash('');
    try {
      await pantryApi.createSnapshot({ title: snapTitle.trim(), lines: lines });
      setSnapTitle('');
      setSnapLines([]);
      setPantryFlash('Snapshot saved — everyone on this MealPrep instance can see it.');
      await loadSnapshots();
    } catch (err) {
      setPantryFlash(err.message || 'Could not save.');
    }
    setSnapSaving(false);
  };

  var toggleSnapshotLine = async function (snap, idx) {
    var lines = (snap.lines || []).map(function (L, i) {
      return { name: L.name, have: i === idx ? !L.have : !!L.have };
    });
    try {
      await pantryApi.updateSnapshot(snap._id, { lines: lines });
      await loadSnapshots();
    } catch (err) {
      if (String(err.message || '').indexOf('Session expired') !== -1) onLogout();
    }
  };

  var addPantryLineToGrocery = async function (name) {
    var n = String(name || '').trim();
    if (!n) return;
    try {
      await groceryApi.addItem({
        name: n,
        amount: '',
        unit: '',
        category: pantryApi.guessGroceryCategory(n),
        recipeSource: 'Pantry — need to buy',
      });
      setPantryFlash('Added “' + n + '” to your grocery list.');
    } catch (err) {
      setPantryFlash(err.message || 'Could not add to grocery list.');
    }
  };

  var addAllMissingToGrocery = async function (snap) {
    var names = (snap.lines || []).filter(function (L) { return L && !L.have && L.name; }).map(function (L) { return String(L.name).trim(); });
    if (!names.length) return;
    try {
      var items = names.map(function (n) {
        return {
          name: n,
          amount: '',
          unit: '',
          category: pantryApi.guessGroceryCategory(n),
          recipeSource: 'Pantry — need to buy',
        };
      });
      await groceryApi.addItemsBulk(items);
      setPantryFlash('Added ' + names.length + ' item(s) to your grocery list.');
    } catch (err) {
      setPantryFlash(err.message || 'Bulk add failed.');
    }
  };

  var dupSnapshot = async function (id) {
    try {
      await pantryApi.duplicateSnapshot(id);
      await loadSnapshots();
      setPantryFlash('Duplicated as a new snapshot for today.');
    } catch (err) {
      setPantryFlash(err.message || 'Duplicate failed.');
    }
  };

  var delSnapshot = async function (id) {
    if (!window.confirm('Delete this pantry snapshot?')) return;
    try {
      await pantryApi.deleteSnapshot(id);
      await loadSnapshots();
      setPantryFlash('Snapshot removed.');
    } catch (err) {
      setPantryFlash(err.message || 'Delete failed.');
    }
  };

  return (
    <Page>
      <Section>
        <SectionTitle>Pantry snapshots</SectionTitle>
        <PantryHint>
          Shared checklist for your kitchen: what you have on hand (dated snapshots you can duplicate next week).
          All signed-in users see the same pantry board; marking something “Out” and tapping + Grocery adds it to your personal grocery list.
        </PantryHint>
        {pantryFlash && <FlashOk>{pantryFlash}</FlashOk>}

        <NewSnapBox>
          <SectionTitle style={{ marginBottom: 10, fontSize: '0.95rem' }}>New check-in</SectionTitle>
          <TagInput style={{ marginBottom: 10 }}>
            <Input
              value={snapTitle}
              onChange={function (e) { setSnapTitle(e.target.value); }}
              placeholder="Optional title (e.g. “Before weekend shop”)"
              style={{ minHeight: 44 }}
            />
          </TagInput>
          <SnapToolbar style={{ marginTop: 0, marginBottom: 12 }}>
            <GhostBtn type="button" onClick={fillStapleTemplate}>Fill staples template</GhostBtn>
            <GhostBtn type="button" onClick={addBlankSnapLine}>+ Blank row</GhostBtn>
          </SnapToolbar>
          {snapLines.map(function (row, idx) {
            return (
              <LineEditor key={idx}>
                <SmallInp
                  value={row.name}
                  onChange={function (e) { setSnapLine(idx, { name: e.target.value }); }}
                  placeholder="Item name"
                />
                <HavePill type="button" $have={row.have} onClick={function () { setSnapLine(idx, { have: !row.have }); }}>
                  {row.have ? 'Have' : 'Out'}
                </HavePill>
                <GhostBtn type="button" onClick={function () { removeSnapLine(idx); }}>Remove</GhostBtn>
              </LineEditor>
            );
          })}
          <SearchBtn type="button" onClick={saveNewSnapshot} disabled={snapSaving || !snapLines.length} style={{ marginTop: 8, marginBottom: 0 }}>
            {snapSaving ? 'Saving…' : 'Save snapshot'}
          </SearchBtn>
        </NewSnapBox>

        {snapshotsLoading ? (
          <Empty style={{ padding: 24 }}>Loading pantry history…</Empty>
        ) : snapshots.length === 0 ? (
          <Empty style={{ padding: 24 }}>No snapshots yet — save your first check-in above.</Empty>
        ) : (
          snapshots.map(function (snap) {
            var when = snap.takenAt ? new Date(snap.takenAt).toLocaleString() : '';
            var missing = (snap.lines || []).filter(function (L) { return L && !L.have && L.name; });
            return (
              <SnapCard key={snap._id}>
                <SnapHead>
                  <div>
                    <SnapTitle>{snap.title || 'Pantry check-in'}</SnapTitle>
                    <div style={{ marginTop: 4 }}>
                      <SnapMeta>{when}{snap.creatorUsername ? ' · logged by ' + snap.creatorUsername : ''}</SnapMeta>
                    </div>
                  </div>
                </SnapHead>
                {(snap.lines || []).map(function (line, idx) {
                  return (
                    <LineRow key={idx}>
                      <span style={{ color: '#fff', fontSize: '0.92rem' }}>{line.name}</span>
                      <RowActions>
                        <HavePill type="button" $have={!!line.have} onClick={function () { toggleSnapshotLine(snap, idx); }}>
                          {line.have ? 'Have' : 'Out'}
                        </HavePill>
                        {!line.have && (
                          <GhostBtn type="button" onClick={function () { addPantryLineToGrocery(line.name); }}>
                            + Grocery
                          </GhostBtn>
                        )}
                      </RowActions>
                    </LineRow>
                  );
                })}
                <SnapToolbar>
                  {missing.length > 0 && (
                    <GhostBtn type="button" onClick={function () { addAllMissingToGrocery(snap); }}>
                      Add all out-of-stock to grocery ({missing.length})
                    </GhostBtn>
                  )}
                  <GhostBtn type="button" onClick={function () { dupSnapshot(snap._id); }}>Duplicate as new snapshot</GhostBtn>
                  <DangerGhost type="button" onClick={function () { delSnapshot(snap._id); }}>Delete</DangerGhost>
                </SnapToolbar>
              </SnapCard>
            );
          })
        )}
      </Section>

      <Section>
        <SectionTitle>What ingredients do you have?</SectionTitle>
        <TagInput>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flex: 1, gap: 8 }}>
            <Input value={inputVal} onChange={function (e) { setInputVal(e.target.value); }}
              placeholder="Type an ingredient..." />
            <AddBtn type="submit">+</AddBtn>
          </form>
        </TagInput>

        {suggestions.length > 0 && (
          <div style={{ marginBottom: 12 }}>
            {suggestions.slice(0, 8).map(function (s) {
              return <QuickAdd key={s} onClick={function () { addIngredient(s); }}>{s}</QuickAdd>;
            })}
          </div>
        )}

        {ingredients.length > 0 && (
          <Tags>
            {ingredients.map(function (ing) {
              return (
                <Tag key={ing}>
                  {ing}
                  <TagRemove onClick={function () { removeIngredient(ing); }}>✕</TagRemove>
                </Tag>
              );
            })}
          </Tags>
        )}

        <SearchBtn onClick={search} disabled={!ingredients.length || loading}>
          {loading ? 'Searching...' : '🔍 Find Recipes (' + ingredients.length + ' ingredients)'}
        </SearchBtn>
      </Section>

      {results !== null && (
        results.length === 0 ? (
          <Empty>No recipes match all those ingredients. Try adding more or different ones.</Empty>
        ) : (
          <div>
            <SectionTitle>{results.length} recipe{results.length !== 1 ? 's' : ''} you can make</SectionTitle>
            <Grid>
              {results.map(function (recipe) {
                var color = CATEGORY_COLORS[recipe.category] || theme.accent;
                var totalTime = (recipe.prepTime || 0) + (recipe.cookTime || 0);
                return (
                  <Card key={recipe._id}>
                    <CardTitle>
                      {recipe.title}
                      <MatchBadge>✓ match</MatchBadge>
                    </CardTitle>
                    <CategoryBadge $color={color}>{recipe.category}</CategoryBadge>
                    <Meta>
                      {recipe.servings > 0 && <span>🍽️ {recipe.servings}</span>}
                      {totalTime > 0 && <span>⏰ {totalTime}m</span>}
                    </Meta>
                    {recipe.description && <Desc>{recipe.description}</Desc>}
                    {recipe.ingredients?.length > 0 && (
                      <IngList>
                        <IngLabel>Ingredients</IngLabel>
                        {recipe.ingredients.map(function (ing, i) {
                          return <IngItem key={i}>{ing.amount} {ing.unit} {ing.name}</IngItem>;
                        })}
                      </IngList>
                    )}
                    <AddToListBtn onClick={function () { addToGrocery(recipe); }}
                      disabled={!!addedSet[recipe._id] || !recipe.ingredients?.length}>
                      {addedSet[recipe._id] ? '✓ Added' : '🛒 Grocery list'}
                    </AddToListBtn>
                  </Card>
                );
              })}
            </Grid>
          </div>
        )
      )}
    </Page>
  );
};

export default WhatCanIMakePage;
